import { motion } from "framer-motion";

export const AnimatedLogo = ({ src, className = "", alt = "Trey's Trucking Logistics" }) => {
  return (
    <motion.div
      className={`relative inline-flex overflow-hidden ${className}`}
      initial={{ opacity: 0, x: -14 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.05 }}
      data-testid="animated-logo"
    >
      <motion.img
        src={src}
        alt={alt}
        className="h-full w-auto object-contain"
        animate={{ y: [0, -1.5, 0] }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="pointer-events-none absolute inset-0"
        initial={{ x: "-130%" }}
        animate={{ x: "130%" }}
        transition={{ duration: 2, repeat: Infinity, repeatDelay: 3.5, ease: "easeInOut" }}
        style={{
          background:
            "linear-gradient(105deg, transparent 42%, rgba(255,255,255,0.38) 50%, transparent 58%)",
        }}
      />
    </motion.div>
  );
};
